export default __webpack_public_path__ + "static/media/sticker-oe.9dbf85f1.png";